import { render } from "./Activity_invoicelist.vue?vue&type=template&id=55237405"
import script from "./Activity_invoicelist.vue?vue&type=script&lang=js"
export * from "./Activity_invoicelist.vue?vue&type=script&lang=js"
script.render = render

export default script